import './InvoiceHistory.less';
import React, { useState } from 'react';
import { useFetchInvoicesQuery } from './service';
import LoadingIndicator from '../components/shared/LoadingIndicator/LoadingIndicator';
import { Button, List, Tag } from 'antd';
import moment from 'moment';
import useDownloadPdfInvoice from './hooks/useDownloadPdfInvoice';

export default function InvoiceHistory() {
    const [downloadingInvoiceNumber, setDownloadingInvoiceNumber] = useState<number>(-1);

    const { data: invoicesData, isLoading: isLoadingInvoices } = useFetchInvoicesQuery();
    const { downloadPdfInvoice, isDownloadingPdfInvoice } = useDownloadPdfInvoice();

    const handleDownloadButtonClicked = (event: React.MouseEvent<HTMLElement, MouseEvent>, invoiceNumber: number) => {
        event.currentTarget.blur();
        setDownloadingInvoiceNumber(invoiceNumber);
        downloadPdfInvoice(invoiceNumber);
    };

    return (
        <div className="invoice-history">
            {isLoadingInvoices && <LoadingIndicator />}

            {!isLoadingInvoices && invoicesData && (
                <List
                    className="invoice-list"
                    size="large"
                    header={<div>Invoice history</div>}
                    bordered
                    dataSource={invoicesData.invoices}
                    locale={{ emptyText: 'No invoices for your account' }}
                    renderItem={(item) => (
                        <List.Item className="invoice-list-item">
                            <div>
                                <div className="date">
                                    <span>{moment(item.created_at, 'YYYY-MM-DDTHH:mm:ss').format('MMM DD, YYYY')}</span>
                                    {item.status === 'paid' ? <Tag color="green">paid</Tag> : <Tag color={'red'}>unpaid</Tag>}
                                </div>
                                <div className="price">
                                    {item.total_in_cents > 0 ? `$${item.total_in_cents / 100}` : `-$${(item.total_in_cents / 100) * -1}`}
                                </div>
                            </div>
                            <Button
                                icon="download"
                                loading={isDownloadingPdfInvoice && downloadingInvoiceNumber === item.invoice_number}
                                onClick={(event) => handleDownloadButtonClicked(event, item.invoice_number)}
                            />
                        </List.Item>
                    )}
                />
            )}
        </div>
    );
}
